// Angular
import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
// 3rd-party
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
// models
import { DropdownOption } from 'src/app/models';

@Component({
    selector: 'app-field-search-multiselect',
    templateUrl: './field-search-multiselect.component.html',
    styleUrls: ['./field-search-multiselect.component.scss'],
    standalone: false
})
export class FieldSearchMultiselectComponent implements OnInit, OnChanges {
    @Input() allowClear: boolean = true;
    @Input() model: any[] = [];
    @Input() options: any[] = [];
    @Input() placeholder: string = '';
    @Input() withGroups: boolean = false;
    @Input() groupedOptions: { title: string; options?: DropdownOption<any>[] }[];

    @Output() modelChange = new EventEmitter();

    localGroupedOptions: { title: string; options?: DropdownOption<any>[]; value?: undefined }[];
    helper: any = {
        selected: []
    };

    @HostListener('document:keydown.enter', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => {
            this.closeForm();
        }, 1);
    }

    ngOnInit(): void {
        if (this.placeholder) {
            if (this.withGroups) {
                this.localGroupedOptions = [{ title: this.placeholder, value: undefined }, ...this.groupedOptions];
            }
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!this.model) this.model = [];
        this.setSelected();
    }

    setSelected() {
        if (this.withGroups) {
            this.helper.selected = [];
            this.groupedOptions.forEach((groupedOption) => {
                const filteredOptions = groupedOption.options.filter((item) => {
                    return this.model.indexOf(item.value) !== -1;
                });
                filteredOptions.forEach((option) => {
                    this.helper.selected.push(option);
                });
            });
        } else {
            this.helper.selected = this.options.filter((item) => {
                return this.model.indexOf(item.value) !== -1;
            });
        }
    }

    openForm(popover?: NgbPopover) {
        this.helper.FORM = JSON.parse(JSON.stringify({ species: this.model || [] }));
        this.helper.FORM.popover = popover;
    }

    toggleSelect(option) {
        const index = this.helper.FORM.species.indexOf(option.value);
        if (index === -1) {
            this.helper.FORM.species.push(option.value);
        } else this.helper.FORM.species.splice(index, 1);

        this.closeForm();
    }

    closeForm() {
        if (!this.helper.FORM?.species) return;
        this.modelChange.emit(this.helper.FORM.species);
        // if (this.helper.FORM.popover) this.helper.FORM.popover.close();
        // this.helper.FORM = null;
    }

    clear() {
        if (this.helper.FORM.popover) this.helper.FORM.popover.close();
        this.helper.FORM = null;
        this.modelChange.emit([]);
    }
}
